export default __webpack_public_path__ + "static/media/Andrew Friedson.a6c9c86e.jpg";